import Spinner from "ui/components/Spinner";

const AppSpinner = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => (
  <div className={`AppSpinner ${className}`}>
    <Spinner className="AppSpinner-icon" />
    {children}
  </div>
);

export default AppSpinner;
